import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'app-label-component',
  templateUrl: './label-component.component.html',
  styleUrls: ['./label-component.component.scss'],
})
export class LabelComponentComponent implements OnInit {
  @Input() labelData: any = [];

  constructor(private navController: NavController) {}

  ngOnInit() {}
  upgradeMembership() {
    if (this.labelData?.isLocked) {
      this.navController.navigateForward([`/upgrade-subscription`]);
    }
  }
}
